module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 16\" preserveAspectRatio=\"xMaxYMax meet\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#A2B0D5\"><rect width=\"23\" height=\"15\" x=\".5\" y=\".5\" rx=\"3\"/><path d=\"M16.05 8.29l-5.94 2.97a.5.5 0 0 1-.73-.45V4.87a.5.5 0 0 1 .73-.45l5.94 2.97a.5.5 0 0 1 0 .9z\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/play-hollow.svg
// module id = NhVm
// module chunks = 5